<template>
  <div class="container">
    <div class="collect">
      <div class="collect-tab">我的收藏</div>
    </div>
    <!--
      引入产品列表  region用来区分页面调用,我以文件名作为区分-->
    <div class="collectBox">
      <CollectList ref="CollectFrom" region="myCollection" :lastId="lastId" :pageIndex="pageIndex" :pageSize="pageSize"></CollectList>
    </div>

    <!-- 引入分页器 -->
    <div class="PagePagination">
      <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>
    </div>
  </div>
</template>

<script>
  import CollectList from "../../components/collectList/collectList"; //引入产品列表
  import PagePagination from "../../components/pagePagination/pagePagination"; //引入分页器
  export default {
    name: "myCollection",
    components: {
      CollectList,
      PagePagination,
    },
    data() {
      return {
        lastId: "",
        pageIndex: 1,
        pageSize: 12,
        total: 0
      };
    },
    created() {

    },

    watch: {
      pageIndex(n, o) {
        console.log(n, o)
      }
    },
    methods: {
      changePageInfo(current, size, total) {
        this.pageIndex = current;
        this.pageSize = size;
        this.total = total
        setTimeout(() => {
          //this.$refs.ProductFrom.getProductList()
        }, 100)
      },
      changePageIndex(page) {
        this.pageIndex = page;
        setTimeout(() => {
          this.$refs.CollectFrom.getCollectList()
        }, 100)
      }
    },
  };
</script>

<style scoped>
  .container {
    width: 100%;
  }

  .collect {
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #C7C7C7;
  }

  .collect-tab {
    width: 66px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 22px;
    color: #3A3A3A;
    line-height: 64px;
    margin: 0 45px;
  }

  .collectBox {
    /* background-color: pink; */
    margin: 20px 0 0 46px;
  }

  .PagePagination {
    width: 63%;
    margin: 0px 18.5% 0px 18.5%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/myCollection/myCollection.vue